import React, { useState } from 'react';
import {
  storage,
  firestore,
} from '../../../configs/environments/firebase/firebaseApp';
import { withRouter } from 'react-router-dom';
import CardProfile from '../../../components/Profile/Card/';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import { compose } from 'redux';
import { makeStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import './Look.scss';
import { onFileLoaded } from '../../../store/actions/AuthUserAction';
import {
  lookAbout,
  deleteProfileImage,
} from '../../../store/actions/UserAction';
import Snackbar from '../../../components/Snackbar';
import { isMobile } from 'react-device-detect';
import {
  Tooltip,
  ClickAwayListener,
  Button,
  Typography,
} from '@material-ui/core';
import CoverPhotosModal from '../../../components/Modal/CoverPhotosModal';
import Popup from '../../../components/Modal/PopUp';
import TrophieModal from '../../../components/Modal/TrophieModal';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import FaceLook from '../FaceLook';
import { PROFILE_COVERS } from '../../../utils/CoverImages';

const maleAvatar = '/img/avatars/avatares-cuadro-h.svg';
const femaleAvatar = '/img/avatars/avatares-cuadro-m.svg';
const lawFirmAvatar = '/img/avatars/avatares-cuadro-logo.svg';

const useStyles = makeStyles({
  cardHeader: {
    display: 'block',
    paddingBottom: 0,
    fontSize: 22,
    '&:after': {
      content: '""',
      display: 'block',
      margin: '0 auto',
      width: '100%',
      paddingBottom: '8px',
      borderBottom: '1px solid #c1c1c1',
    },
  },
  inputFile: {
    display: 'none',
  },
  buttonImage: {
    color: '#013957',
    border: '1px solid #013957',
    borderRadius: 20,
    width: 160,
    height: 40,
    '&:hover': {
      color: 'white',
      backgroundColor: '#35b9b6',
      border: 'none',
    },
    '@media(max-width: 768px)': {
      width: 152,
    },
  },
  buttonName: {
    fontSize: 16,
    fontWeight: 'bold',
    textTransform: 'initial',
    lineHeight: 'normal',
  },
  customTooltip: {
    backgroundColor: '#094565',
    margin: '4px 0 0',
    padding: 8,
    maxWidth: 216,
    width: 206,
    lineHeight: 1.2,
  },
  tooltipParagraph: {
    margin: 0,
    fontSize: 14,
    '& b': {
      fontSize: 14,
      fontWeight: 'bold',
    },
  },
});

const Look = (props) => {
  const {
    uid,
    imgProfile,
    lookAbout,
    authClient,
    trophie,
    deleteProfileImage,
    showLoading, 
    hideLoading,
  } = props;

  const defaultAvatar =
    authClient && authClient.role === 'lawyer'
      ? authClient.genero === 'male'
        ? maleAvatar
        : femaleAvatar
      : lawFirmAvatar;

  const classes = useStyles();
  const [image, setImage] = useState(null);
  const [imgenPortada, setimgenPortada] = useState(
    (authClient && authClient.imgenPortada && authClient.imgenPortada) || 23
  );
  const [url, setUrl] = useState();
  const [urlCover, setUrlCover] = useState();
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [ openTrophieModal, setOpenTrophieModal ] = useState(false);
  const [coverOnPreview, setCoverOnPreview] = useState((authClient && authClient.imgenPortada && authClient.imgenPortada) || 23);


  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success',
  });

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success',
    });
  };

  const revisar = (elemento) => {
    setimgenPortada(elemento);
    console.log('elemento?', elemento)
  };
  /* 86kb byte  83,593  */
  const handleChange = (e) => {
    const { files } = e.target;

    if (files.length > 0) {
      const fsize = files[0].size;
      const file = Math.round(fsize / 1024);
      if (file >= 4096) {
        alert('Imagen mayor a 4MB porfavor ingrese una de menor peso');
      } else {
        const localImageUrl = window.URL.createObjectURL(files[0]);
        setImage(files[0]);
        setUrl(localImageUrl);
        props.onFileLoaded(localImageUrl);
      }
    }
  };

  const handleUpload = () => {
    let achievement = false;
    showLoading()
    if (image) {
      // achievement
      const boolValues = true;
      const uploadTask = storage.ref(`profileImage/${uid}/avatar`).put(image);
      uploadTask.on(
        'state_changed',
        (snapShot) => {
          //takes a snap shot of the process as it is happening
        },
        (err) => {
          //catches the errors
        },
        () => {
          // gets the functions from storage refences the image storage in firebase by the children
          // gets the download url then sets the image from firebase as the value for the imgUrl key:

          storage
            .ref(`profileImage/${uid}`)
            .child('avatar')
            .getDownloadURL()
            .then((fireBaseUrl) => {
              console.log('En firebase', fireBaseUrl);

              achievement = true;
              lookAbout(
                fireBaseUrl,
                uid,
                imgenPortada,
                achievement,
                boolValues
              ).then((res) => {});
              hideLoading();
              trophie &&
                setFeedbackMessage({
                  open: true,
                  message: 'Tus cambios se han guardado con éxito',
                  variant: 'success',
                });
              !trophie && setOpenTrophieModal(true);
            });
        }
      );
    } else {
      firestore
        .collection('lawyerUsers')
        .doc(uid)
        .set({ imgenPortada: imgenPortada }, { merge: true })
        .then(() => {
          hideLoading();
          setFeedbackMessage({
            open: true,
            message: 'Tus cambios se han guardado con éxito',
            variant: 'success',
          });
        });
    }
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const defaultCover = '/img/profile/cover/23.png';
  const imgCover =
    authClient &&
    authClient.imgenPortada &&
    `/img/profile/cover/${authClient.imgenPortada}.png`;

  const selectCover = () => {
    setUrlCover(`/img/profile/cover/${imgenPortada}.png`);
    setCoverOnPreview(imgenPortada);
    handleCloseModal();
  };

  const cancelCover = () => {
    //setUrlCover(null);
    //setCoverOnPreview((authClient && authClient.imgenPortada && authClient.imgenPortada) || 23);
    handleCloseModal();
  };

  const toggleModalDelete = () => {
    setOpenModalDelete(!openModalDelete);
  };

  const handleCloseTrophieModal = () => {
    setOpenTrophieModal(false);
  };

  const confirmDeleteImage = () => {
    console.log('eliminar imagen');
    toggleModalDelete();
    showLoading();
    const boolValues = false;
    //handleDelete();
    //console.log('profileImage url', imgProfile);
    deleteProfileImage(uid, imgProfile, boolValues).then((res) => {
      hideLoading()
      setFeedbackMessage({
        open: true,
        message: 'La imagen se eliminó exitosamente',
        variant: 'success',
      });
    });
  };

  return (
    <>
      <div className={'look'}>
       
        <CardProfile
          title={'Apariencia'}
          subTitle={
            authClient && authClient.role === 'lawFirm'
              ? 'Agrega el logo de tu despacho.'
              : 'Agrega una foto de perfil. Que las personas conozcan y ubiquen tu imagen siempre es importante.'
          }
          awardIcon
          status={
            authClient && authClient.awardPerfil.look
              ? authClient.awardPerfil.look
              : false
          }
        >
          <div className="fotoUser">
            <div
              className="item1"
              style={{
                backgroundImage: `url(${
                  imgProfile
                    ? !url
                      ? imgProfile
                      : url
                    : !url
                    ? defaultAvatar
                    : url
                })`,
              }}
            >
              {!url ? (
                (imgProfile === '' || !imgProfile) ? null : (
                  <div className="item1-trash">
                    <img
                      src="/img/profile/trash.svg"
                      onClick={() => {
                        setOpenModalDelete(true);
                      }}
                      alt="borrar"
                    />
                  </div>
                )
              ) : (
                <div className="item1-trash">
                  <img
                    src="/img/profile/trash.svg"
                    onClick={() => {
                      setUrl(null);
                      setImage(null);
                    }}
                    alt="borrar"
                  />
                </div>
              )}
            </div>

            <div className="container-lawfirm">
              <span className="item1-lawfirm">Imagen de usuario</span>
              <div className="subcontainer-lawfirm">
                <span className="item2-lawfirm">
                  (Tamaño máximo 100 KB. JPG, PNG.) &nbsp;&nbsp;
                </span>
                <div className="item3-lawfirm">
                  {isMobile === true ? (
                    <ClickAwayListener onClickAway={handleTooltipClose}>
                      <Tooltip
                        PopperProps={{
                          disablePortal: true,
                        }}
                        onClose={handleTooltipClose}
                        open={open}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                        classes={{ tooltip: classes.customTooltip }}
                        title={
                          <p className={classes.tooltipParagraph}>
                            El <b>peso</b> de la foto <b>no</b> debe ser{' '}
                            <b>mayor a 100KB</b> y debe tener un tamaño mínimo
                            de 176x176px.
                          </p>
                        }
                        placement="left"
                      >
                        <img
                          src="/img/profile/ayuda.png"
                          alt="?"
                          onClick={handleTooltipOpen}
                        />
                      </Tooltip>
                    </ClickAwayListener>
                  ) : (
                    <Tooltip
                      classes={{ tooltip: classes.customTooltip }}
                      title={
                        <p className={classes.tooltipParagraph}>
                          El <b>peso</b> de la foto <b>no</b> debe ser{' '}
                          <b>mayor a 4MB</b> y debe tener un tamaño mínimo de
                          176x176px.
                        </p>
                      }
                      placement="bottom"
                    >
                      <img src="/img/profile/ayuda.png" alt="?" />
                    </Tooltip>
                  )}
                </div>
              </div>
            </div>

            <div className="horizontal-layout item5">
              <input
                type="file"
                onChange={handleChange}
                className={classes.inputFile}
                id="profile_image"
                name="profile_image"
                accept=".jpg, .jpeg, .png"
              />

              <label htmlFor="profile_image">
                <Button
                  variant="outlined"
                  className={classes.buttonImage}
                  component="span"
                >
                  <Typography className={classes.buttonName}>
                    Seleccionar foto
                  </Typography>
                </Button>
              </label>
            </div>
          </div>

          <br></br>
          <p id="t1">Foto de portada</p>

          {authClient && authClient.role === 'lawFirm' ? (
            <p id="t3">
              Selecciona alguna de las siguientes opciones para la portada del
              perfil del despacho.
            </p>
          ) : (
            <p id="t3">
              Selecciona alguna de las siguientes opciones para tu portada de
              perfil.
            </p>
          )}

          <div
            className="look_cover_container"
            style={{
              backgroundImage: `url(${
                imgCover
                  ? !urlCover
                    ? imgCover
                    : urlCover
                  : !urlCover
                  ? defaultCover
                  : urlCover
              })`,
            }}
            onClick={() => setOpenModal(true)}
          >
            <div className="look_container_add">
              <img
                className="insertar-foto"
                src="/img/profile/insertar-foto.svg"
                alt=""
              />
            </div>
          </div>

          {/* <FaceLook checkValue={revisar} /> */}

          <div className="horizontal-layout" style={{ marginTop: 24 }}>
            <ButtonBase
              type="submit"
              onClick={handleUpload}
              variant="primary"
              // disabled={!isValid}
              classes={{ root: classes.ButtonBase }}
            >
              Guardar cambios
            </ButtonBase>
          </div>
        </CardProfile>
        <Snackbar
          open={feedbackMessage.open}
          message={feedbackMessage.message}
          variant={feedbackMessage.variant}
          handleClose={handleCloseFeedbackMessage}
          vertical="top"
          horizontal="right"
          snackbarTop={isMobile ? '70px' : '80px'}
        />
      </div>
      <Popup
        open={openModalDelete}
        handleClose={toggleModalDelete}
        title={['¿Seguro que deseas eliminar tu', <br />, 'foto de perfil?']}
        subtitle="Si eliminas tu foto de perfil es poco probable que posibles clientes puedan reconocerte. Para regresar da click en el botón Cancelar."
        primaryButton={true}
        primaryButtonVariant="primarySolidOutlined"
        primaryButtonText="Sí, Eliminar"
        primaryFunction={confirmDeleteImage}
        secondaryButton={true}
        secondaryButtonVariant="primary"
      />

      <CoverPhotosModal
        checkValue={revisar}
        open={openModal}
        handleClose={handleCloseModal}
        selectCover={selectCover}
        cancelCover={cancelCover}
        coverOnPreview = {coverOnPreview}
        coversContainer={
          <FaceLook
            checkValue={revisar}
            coverOnPreview={coverOnPreview}
            covers={PROFILE_COVERS}
          />
        }
      />
      <TrophieModal
        keyItem={'lookTrophieModal'}
        open={openTrophieModal}
        trophieValidation={trophie}
        topic="award-profile"
        handleClose={handleCloseTrophieModal}
        title='Apariencia'
        subtitle={['¡Felicidades', <br />, 'haz obtenido este logro!']}
        footer='Una buena apariencia te da mayor presencia, confianza y formalidad.'
      /> 
    </>
  );
};

const mapStateToProps = (state) => ({
  formValues: state.formValues,
  uid: state.authClient.uid,
  authClient: state.authClient,
  imgProfile: state.authClient.imgProfile,
  trophie: state.authClient.awardPerfil.look,
});

const mapDispatchToProps = (dispatch) => ({
  onFileLoaded: (localImageUrl) => dispatch(onFileLoaded(localImageUrl)),
  lookAbout: (fireBaseUrl, uid, imgenPortada, achievement, boolValues) =>
    dispatch(
      lookAbout(fireBaseUrl, uid, imgenPortada, achievement, boolValues)
    ),
  deleteProfileImage: (uid, pathImgItem, boolValues) =>
    dispatch(deleteProfileImage(uid, pathImgItem, boolValues)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
});

const LookCompress = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Look);

export default LookCompress;
